import { MediaType } from '@/types'

export const MEDIA_TYPE_TO_DISPLAY_NAME: Record<MediaType, string> = {
  [MediaType.Image]: 'Image',
  [MediaType.Video]: 'Video',
  [MediaType.Audio]: 'Audio',
  [MediaType.Document]: 'Document',
}
